import React, { useState, useEffect } from 'react';
import FormationCard from '../components/FormationCard';
import { formationService } from '../services/formationService';
import './FormationsPage.css';

const FormationsPage = () => {
    const [formations, setFormations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [filters, setFilters] = useState({
        type: '',
        niveau: '',
        search: ''
    });

    useEffect(() => {
        loadFormations();
    }, [filters.type, filters.niveau]);

    const loadFormations = async () => {
        try {
            setLoading(true);
            setError(null);
            
            const data = await formationService.getAllFormations({
                type: filters.type,
                niveau: filters.niveau,
                per_page: 20
            });
            
            if (data.success) {
                console.log('✅ Formations chargées:', data.formations);
                setFormations(data.formations);
            } else {
                setError('Erreur lors du chargement des formations');
            }
        } catch (err) {
            console.error('❌ Erreur:', err);
            setError('Impossible de charger les formations. Vérifiez que le backend est accessible.');
        } finally {
            setLoading(false);
        }
    };

    const handleFilterChange = (filterName, value) => {
        setFilters(prev => ({
            ...prev,
            [filterName]: value
        }));
    };

    const handleSearchChange = (e) => {
        setFilters(prev => ({
            ...prev,
            search: e.target.value.toLowerCase()
        }));
    };

    // Filtrer les formations par recherche
    const filteredFormations = formations.filter(formation => {
        if (!filters.search) return true;
        return formation.titre.toLowerCase().includes(filters.search) ||
               (formation.description && formation.description.toLowerCase().includes(filters.search));
    });

    if (loading) {
        return (
            <div className="formations-page">
                <div className="container">
                    <div className="loading-container">
                        <div className="spinner"></div>
                        <p>Chargement des formations...</p>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="formations-page">
                <div className="container">
                    <div className="error-container">
                        <div className="error-icon">⚠️</div>
                        <h2>Erreur de chargement</h2>
                        <p>{error}</p>
                        <button onClick={loadFormations} className="btn-retry">
                            Réessayer
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="formations-page">
            <div className="container">
                
                {/* En-tête */}
                <div className="page-header">
                    <h1>Nos Formations</h1>
                    <p className="page-subtitle">
                        Formations professionnelles en douane, transit et commerce international
                    </p>
                </div>

                {/* Barre de recherche et filtres */}
                <div className="filters-section">
                    <div className="search-bar">
                        <input
                            type="text"
                            placeholder="Rechercher une formation..."
                            value={filters.search}
                            onChange={handleSearchChange}
                            className="search-input"
                        />
                        <span className="search-icon">🔍</span>
                    </div>

                    <div className="filters">
                        <select
                            value={filters.type}
                            onChange={(e) => handleFilterChange('type', e.target.value)}
                            className="filter-select"
                        >
                            <option value="">Tous les types</option>
                            <option value="presentiel">Présentiel</option>
                            <option value="ligne">En ligne</option>
                            <option value="hybride">Hybride</option>
                        </select>

                        <select
                            value={filters.niveau}
                            onChange={(e) => handleFilterChange('niveau', e.target.value)}
                            className="filter-select"
                        >
                            <option value="">Tous les niveaux</option>
                            <option value="debutant">Débutant</option>
                            <option value="intermediaire">Intermédiaire</option>
                            <option value="avance">Avancé</option>
                            <option value="tous_niveaux">Tous niveaux</option>
                        </select>

                        {(filters.type || filters.niveau || filters.search) && (
                            <button
                                onClick={() => setFilters({ type: '', niveau: '', search: '' })}
                                className="btn-clear-filters"
                            >
                                ✕ Réinitialiser
                            </button>
                        )}
                    </div>
                </div>

                {/* Statistiques */}
                <div className="stats-bar">
                    <span className="stat-item">
                        <strong>{filteredFormations.length}</strong> formation{filteredFormations.length > 1 ? 's' : ''} trouvée{filteredFormations.length > 1 ? 's' : ''}
                    </span>
                </div>

                {/* Grille de formations */}
                {filteredFormations.length === 0 ? (
                    <div className="no-results">
                        <div className="no-results-icon">📚</div>
                        <h3>Aucune formation trouvée</h3>
                        <p>Essayez de modifier vos critères de recherche</p>
                        <button
                            onClick={() => setFilters({ type: '', niveau: '', search: '' })}
                            className="btn-reset"
                        >
                            Voir toutes les formations
                        </button>
                    </div>
                ) : (
                    <div className="formations-grid">
                        {filteredFormations.map(formation => (
                            <FormationCard 
                                key={formation.id} 
                                formation={formation} 
                            />
                        ))}
                    </div>
                )}

                {/* Appel à l'action */}
                <div className="cta-section">
                    <h2>Besoin d'une formation sur mesure ?</h2>
                    <p>Contactez-nous pour un programme adapté à vos besoins spécifiques</p>
                    <a href="/contact" className="btn-cta">
                        Nous contacter
                    </a>
                </div>

            </div>
        </div>
    );
};

export default FormationsPage;